module.exports = __webpack_public_path__ + "img/about-01.4c7ebf60.png";